@if (details$ | async; as vehicle) {
  <section class="sell-vehicle-detail">
    @if (showHeading) {
      <h3 class="text-uppercase fw-bold h5">{{autoVisionVehicleDetailsTransltions.vehicleDetails}}</h3>
    }
    <div class="row">
      <div class="col-sm-4">
        <app-datalist-item label={{autoVisionVehicleDetailsTransltions.seller}} [value]="vehicle.seller"></app-datalist-item>
        <app-datalist-item label={{autoVisionVehicleDetailsTransltions.odometer}} [value]="getOdometer(vehicle)"></app-datalist-item>
        <app-datalist-item label={{autoVisionVehicleDetailsTransltions.vehicleLocation}} [value]="vehicle.location"></app-datalist-item>
      </div>
      <div class="col-sm-4">
        <app-datalist-item label={{autoVisionVehicleDetailsTransltions.distance}} [value]="vehicle.distance + ' ' + autoVisionVehicleDetailsTransltions.distanceUnit"></app-datalist-item>
        <app-datalist-item label={{autoVisionVehicleDetailsTransltions.titleState}} [value]="vehicle.titleState"></app-datalist-item>
        @if (isMsrpEnabled) {
          <app-datalist-item label="MSRP" [value]="vehicle.msrp"></app-datalist-item>
        }
        <app-datalist-item label={{autoVisionVehicleDetailsTransltions.type}} [value]="vehicle.type"></app-datalist-item>
      </div>
      <div class="col-sm-4">
        <app-datalist-item label={{autoVisionVehicleDetailsTransltions.exterior}} [value]="vehicle.exterior"></app-datalist-item>
        <app-datalist-item label={{autoVisionVehicleDetailsTransltions.interior}} [value]="vehicle.interior"></app-datalist-item>
        <app-datalist-item label={{autoVisionVehicleDetailsTransltions.hits}} [value]="vehicle.hits | number"></app-datalist-item>
      </div>
    </div>
    <div class="row mt-1 pt-3 mb-2">
      <div class="col">
        <div class="border-top"></div>
      </div>
    </div>
    <div class="row">
      <div class="col-xl-8">
        <app-datalist-item label={{autoVisionVehicleDetailsTransltions.sellerComments}}>
          <span
            class="me-2 seller-comments__comment"
            [ngClass]="{'paid-comment':  vehicle.sellerComments !== 'N/A'}"
            >
            {{ vehicle.sellerComments }}
          </span>
        </app-datalist-item>
      </div>
    </div>
  </section>
}
